import { MoveRightIcon } from 'lucide-react'

import { Comment } from '@/gen/inventory/v1/comment_pb'

import { cn } from '@/lib/ui/style-helpers'

type ChangeCardProps = {
  statement: string
  prevBadge: React.ReactNode
  newBadge: React.ReactNode
  comment?: Comment
}

export const ChangeCard = ({ statement, prevBadge, newBadge, comment }: ChangeCardProps) => {
  return (
    <div className={cn('flex flex-col gap-1')}>
      <div className='flex flex-wrap items-center gap-3'>
        {prevBadge}
        <MoveRightIcon className='text-main-foreground-placeholder' size={16} strokeWidth={1.5} />
        {newBadge}
        <span className='text-main-foreground-tertiary text-body-small'>{statement}</span>
      </div>
      {comment?.body}
    </div>
  )
}
